/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayForwardIcon64Regular = forwardRef('MediaUiAPlayForwardIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.736 8.785C25.411 6.611 21 8.997 21 12.97v38.06c0 3.973 4.41 6.359 7.736 4.185l29.105-19.03c3.018-1.974 3.018-6.396 0-8.37L28.736 8.785ZM24 12.97c0-1.59 1.764-2.543 3.095-1.674l29.104 19.03a2 2 0 0 1 0 3.348l-29.104 19.03c-1.33.87-3.095-.085-3.095-1.674V12.97Z" }),
        React.createElement("path", { d: "M13 9.5a1.5 1.5 0 0 0-3 0v45a1.5 1.5 0 0 0 3 0v-45Z" })));
});
